export default __webpack_public_path__ + "static/media/icon_notifications-full.21cdf998.svg";